import { PASTA_QUERY } from '../data/pasta-query'
import { useParams } from 'react-router'
import { ITEMS_POR_PASTA_QUERY } from '../data/items-pasta-query'
import {
  GetItemsPorPastaQuery,
  GetItemsPorPastaQueryVariables,
  GetPastaQuery,
  GetPastaQueryVariables
} from '@/core/types/graphql'
import { request } from '../../../core/utils/request'
import { useQuery } from '@tanstack/react-query'

export const useBibliotecaQueries = () => {
  const params = useParams()

  const { data: getPasta = {}, isLoading: loadingPasta } = useQuery({
    queryKey: ['pasta', params.idPasta],
    queryFn: async () =>
      await request<GetPastaQuery, GetPastaQueryVariables>(PASTA_QUERY, {
        variables: { idPasta: params.idPasta }
      }),
    enabled: !!params.idPasta
  })

  const { data: { itemsPorPasta = {} } = {}, isLoading: loadingItemsPorPasta } =
    useQuery({
      queryKey: ['itemsPorPasta', params.idPasta],
      queryFn: async () =>
        await request<GetItemsPorPastaQuery, GetItemsPorPastaQueryVariables>(
          ITEMS_POR_PASTA_QUERY,
          { variables: { idPasta: params.idPasta } }
        ),
      staleTime: 0
    })

  return {
    getPasta,
    loadingPasta,
    itemsPorPasta,
    loadingItemsPorPasta
  }
}
